import { getLeads, getLeadStats } from '../../../apiclient/resources/leads';
import * as actions from './actions';

const fetchUnread = (status, isMobile) => dispatch => {
  getLeadStats().then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchUnReadSucceeded(data));
    }
  });
};

const changeInbox = (state, isMobile) => dispatch => {
  dispatch(actions.changeInbox(state));
  fetchUnread(state, isMobile)(dispatch);
};

export { fetchUnread, changeInbox };
